import { render, staticRenderFns } from "./CustomerTabPrivacyConsents.vue?vue&type=template&id=db490f52"
import script from "./CustomerTabPrivacyConsents.vue?vue&type=script&lang=ts"
export * from "./CustomerTabPrivacyConsents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports